export default __webpack_public_path__ + "static/media/(19).31a4d7fd.jpg";